/** Push web: avisa tarea nueva y abre el detalle (design.md §22.6). */
import { mobileApiClient } from './mobileApiClient';

export type PushSubscriptionBody = {
  endpoint: string;
  p256dh: string;
  auth: string;
  user_agent?: string;
};

function urlBase64ToUint8Array(base64: string): Uint8Array<ArrayBuffer> {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const normalized = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(normalized);
  const bytes = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) bytes[i] = raw.charCodeAt(i);
  return bytes;
}

export const pushService = {
  supported(): boolean {
    return 'serviceWorker' in navigator && 'PushManager' in window;
  },

  async vapidPublicKey(): Promise<string> {
    const { data } = await mobileApiClient.get('/api/v1/push/vapid-key');
    return data.public_key as string;
  },

  /** Registra la suscripcion del dispositivo contra la membresia activa. */
  async subscribe(): Promise<void> {
    if (!this.supported()) throw new Error('Push no soportado en este dispositivo');
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') throw new Error('Permiso de notificacion denegado');
    const registration = await navigator.serviceWorker.ready;
    const publicKey = await this.vapidPublicKey();
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
    const keys = subscription.toJSON().keys ?? {};
    await mobileApiClient.post('/api/v1/push/subscriptions', {
      endpoint: subscription.endpoint,
      p256dh: keys['p256dh'] ?? '',
      auth: keys['auth'] ?? '',
      user_agent: navigator.userAgent,
    } satisfies PushSubscriptionBody);
  },

  async unsubscribe(endpoint: string): Promise<void> {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    await subscription?.unsubscribe();
    await mobileApiClient.delete('/api/v1/push/subscriptions/by-endpoint', {
      data: { endpoint },
    });
  },
};
